import { useNuxtApp } from '#app';

export const useSubscriptionStore = defineStore('subscription', {
  state: () => ({
    subscribed: false,
  }),
  actions: {
    setSubscribed(value, withCookie = true) {
      if (withCookie) {
        const subscriptionCookie = useCookie('subscribed', {
          path: '/',
          maxAge: 60 * 60 * 24 * 365,
        });

        subscriptionCookie.value = value;
      }
      this.subscribed = value;
    },
    setSubscribedForOneDay() {
      const date = new Date();
      const oneDay = 60 * 60 * 24;
      const diff = date.getTimezoneOffset() * 60;

      const subscriptionCookie = useCookie('subscribed', {
        path: '/',
        maxAge: oneDay - diff,
      });

      subscriptionCookie.value = this.subscribed = 'day';
    },
    async subscribe(payload) {
      const { $proxifyApi } = useNuxtApp();
      try {
        await $proxifyApi.post('/newsletter-subscriber', {
          name: payload.name ?? 'User',
          email: payload.email,
          subscribed_to: 'career',
          subscribed_from: payload.subscribedFrom,
          g_recaptcha: payload.recaptcha,
        });
        this.setSubscribed(true);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async subscribeByAudience(payload) {
      const { $proxifyApi } = useNuxtApp();
      try {
        await $proxifyApi.post('/newsletter-subscriber/store-by-audience', {
          ...payload,
          subscribed_to: 'career',
        });
        this.setSubscribed(true);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
});
